// @ts-expect-error -- there are no types for this library
import JsonApi from 'devour-client';

import type { JsonApiTypeHelper } from './JsonApiTypeHelper.types';
import type { Invoice } from 'Backend/billing/types';

import Config from 'Config';
import { invoiceMiddleware, invoiceRequestMiddleware } from './Middleware';

const InvoicesApi = new JsonApi({ apiUrl: Config.invoices_api });

InvoicesApi.insertMiddlewareBefore('axios-request', invoiceRequestMiddleware);
InvoicesApi.insertMiddlewareAfter('response', invoiceMiddleware);

InvoicesApi.define('invoice', {
    date: '',
    dueDate: '',
    status: '',
    url: '',
    total: '',
    lines: {
        jsonApi: 'hasMany',
        type: 'lines',
    },
});

InvoicesApi.define('line', {
    description: '',
    amount: '',
    unitPrice: '',
    quantity: '',
    invoice: {
        jsonApi: 'hasOne',
        type: 'invoice',
    },
});

const InvoicesApiExport = InvoicesApi as JsonApiTypeHelper<Invoice, '' | 'invoice'>; // I think because "invoice" uses "" as url, it is ok to use "" as the model name here.

export { InvoicesApiExport as InvoicesApi };
